/**
 * `/stores` has no page of its own any more (user, 2026-10-08: no Stores home); old links and the
 * "Stores" breadcrumb land on Arrival, whose pop-up asks the type.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stores/")({
  beforeLoad: () => {
    throw redirect({ to: "/stores/arrivals" });
  },
});
